import { useTranslation } from 'react-i18next'
import UploadImage from 'components/reusables/uploadImage'
import { useNotification } from 'hooks/notifications/useNotification'
import {
  ALLOWED_SIGNATURE_ACCEPT,
  isAllowedSignatureFile,
} from './signatureFileValidation'

interface IProps {
  value?: File | string | null
  onChange?: (value: File | null) => void
  hasError?: boolean
}

const SIGNATURE_UPLOAD_HEIGHT = '150px'
const translatePrefix =
  'administration.certificate.legalAttestationForm.fields.signature'

const FormUploadImage = ({ value, onChange, hasError }: IProps) => {
  const { t } = useTranslation()
  const notification = useNotification()

  return (
    <UploadImage
      image={value ?? null}
      setImage={(file) => onChange?.(file)}
      translatePrefix={translatePrefix}
      fullWidth
      hasError={hasError}
      height={SIGNATURE_UPLOAD_HEIGHT}
      imageFit="contain"
      imageBackgroundColor="#ffffff"
      accept={ALLOWED_SIGNATURE_ACCEPT}
      validateFile={isAllowedSignatureFile}
      onInvalidFileType={() =>
        notification.warning(t(`${translatePrefix}.invalidFormat`))
      }
    />
  )
}

export default FormUploadImage
